import { MenuItem as MuiMenuItem } from '@mui/material';
import { menuItemClasses, MenuItemProps } from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';

import { tokens } from '../../theme/styles/themeMui';

export type { MenuItemProps };

export const MenuItem: React.ComponentType<MenuItemProps> = styled(MuiMenuItem)<MenuItemProps>(
  ({ theme }) => ({
    [`&.${menuItemClasses.root}`]: {
      ...tokens.typography.bodyMRegular,
      alignItems: 'flex-start',
      [`&:hover`]: {
        backgroundColor: theme.palette.colors.core.neutral['200'],
      },
    },
  }),
);
